<template>
  <v-container class="mt-10">
    <a class="anchor" id="exhibitors"></a>
    <div class="col text-center">
      <h2 class="text-center text-uppercase">
        <i class="fas fa-square"></i>
        {{ pageSettings.exhibitorsTitle }}
      </h2>
    </div>
    <p
      class="text-justify"
      v-html="getRichTextString(pageSettings.exhibitorsText, false)"
    ></p>
    <v-data-iterator
      :items="filteredExhibitors"
      :items-per-page.sync="itemsPerPage"
      :page="page"
      :search="search"
      :no-data-text="$t('noEntriesFound')"
      :no-results-text="$t('noEntriesFound')"
      hide-default-footer
    >
      <template #header>
        <v-text-field
          v-model="search"
          outlined
          clearable
          append-icon="mdi-magnify"
          :label="$t('form.fields.search')"
        ></v-text-field>
        <v-chip-group
          multiple
          class="mt-n7 mb-3"
          v-if="tags.length > 0"
          active-class="primary"
          v-model="filterTagIds"
        >
          <v-chip v-for="tag in tags" :key="tag.id" :value="tag.id" filter>
            {{ tag.title }}
          </v-chip>
        </v-chip-group>
      </template>

      <template #default="props">
        <v-row>
          <v-col
            v-for="item in props.items"
            :key="item.id"
            cols="12"
            md="6"
            lg="4"
            class="d-flex flex-column"
          >
            <v-card class="flex d-flex flex-column">
              <v-card-title class="font-weight-bold">
                <div class="exhibitor-image pa-5">
                  <v-img
                    :src="item.company_logo || '/img/logo-placeholder.jpg'"
                    height="70px"
                    contain
                  ></v-img>
                </div>
                <v-clamp autoresize :max-lines="1">
                  {{ item.company_name }}
                </v-clamp>
              </v-card-title>
              <v-divider></v-divider>
              <v-card-text class="richtext pb-5 flex description-text">
                <p class="mt-n4 mb-2 overline">
                  <v-clamp
                    autoresize
                    :max-lines="1"
                    v-if="item.tag_ids && item.tag_ids.length > 0"
                  >
                    {{
                      getTranslatedTags(item)
                        .sort()
                        .join(", ")
                    }}
                  </v-clamp>
                </p>
                <v-clamp autoresize :max-lines="5">
                  <div
                    v-html="
                      getTranslatedText(item.description, item.description_en)
                    "
                  />
                </v-clamp>
              </v-card-text>
              <v-card-actions>
                <v-btn
                  :color="item.hex_color ? item.hex_color : 'primary'"
                  :dark="hasDarkText(item.color)"
                  v-html="$t('form.btn.details')"
                  @click="showDetailView(item)"
                ></v-btn>
              </v-card-actions>
            </v-card>
          </v-col>
        </v-row>
      </template>

      <template #footer v-if="numberOfPages > 1">
        <v-row class="mt-2" align="center" justify="center">
          <v-spacer></v-spacer>

          <span
            class="mr-4 grey--text"
            v-html="
              $t('pagination', { page: page, numberOfPages: numberOfPages })
            "
          >
          </span>
          <v-btn
            color="primary"
            class="mr-1"
            :disabled="page === 1"
            @click="formerPage"
          >
            <v-icon>mdi-chevron-left</v-icon>
          </v-btn>
          <v-btn
            color="primary"
            class="ml-1"
            :disabled="page === numberOfPages"
            @click="nextPage"
          >
            <v-icon>mdi-chevron-right</v-icon>
          </v-btn>
        </v-row>
      </template>
    </v-data-iterator>

    <v-dialog scrollable v-model="detailView" max-width="1000px" persistent>
      <v-card>
        <v-toolbar
          class="headline"
          :color="
            currentExhibitor.hex_color ? currentExhibitor.hex_color : 'primary'
          "
          :dark="hasDarkText(currentExhibitor.hex_color)"
        >
          <v-clamp autoresize :max-lines="1">
            {{ currentExhibitor.company_name }}
          </v-clamp>
          <v-spacer></v-spacer>
          <v-btn
            icon
            :dark="hasDarkText(currentExhibitor.hex_color)"
            @click="detailView = false"
          >
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-toolbar>
        <v-card-text :style="cssVariables">
          <v-row class="body-1 mt-3">
            <div class="hidden-sm-and-down">
              <div
                style="width: 30%; max-width: 300px;"
                class="float-left ma-5 mt-8"
              >
                <v-img
                  :src="
                    currentExhibitor.company_logo || '/img/logo-placeholder.jpg'
                  "
                  contain
                ></v-img>
              </div>
              <div
                class="richtext ml-5 mr-5 mt-2 description-text"
                v-html="
                  getTranslatedText(
                    currentExhibitor.description,
                    currentExhibitor.description_en
                  )
                "
              ></div>
            </div>
            <v-col cols="12" class="hidden-md-and-up">
              <v-img
                :src="
                  currentExhibitor.company_logo || '/img/logo-placeholder.jpg'
                "
                contain
              ></v-img>
            </v-col>
            <v-col
              class="richtext mr-1 hidden-md-and-up"
              v-html="
                getTranslatedText(
                  currentExhibitor.description,
                  currentExhibitor.description_en
                )
              "
            >
            </v-col>
          </v-row>
          <v-row
            class="exhibitor-row richtext body-1 mt-6 mb-6 ml-0"
            v-if="
              currentExhibitor.flyer_file_entries &&
                currentExhibitor.flyer_file_entries.length > 0
            "
          >
            <div class="odd-background"></div>
            <v-col class="mt-n2 pl-3 pt-3 pb-3">
              <span
                v-for="document in currentExhibitor.flyer_file_entries"
                :key="document.id"
              >
                <v-chip
                  close
                  :color="
                    currentExhibitor.hex_color
                      ? currentExhibitor.hex_color
                      : 'primary'
                  "
                  :text-color="
                    hasDarkText(currentExhibitor.hex_color) ? 'white' : 'black'
                  "
                  close-icon="mdi-download"
                  @click:close="downloadDocument(document.asset_url)"
                  class="mt-1 mb-1 mr-2"
                >
                  <v-avatar left>
                    <v-icon small>mdi-file</v-icon>
                  </v-avatar>
                  <div
                    v-html="
                      getTranslatedText(document.title, document.title_en)
                    "
                  ></div>
                </v-chip>
              </span>
            </v-col>
          </v-row>
          <v-row class="exhibitor-row" v-if="hasImageOrVideo(currentExhibitor)">
            <div class="video-container ml-10 mr-10 mt-6 mb-4">
              <v-carousel
                height="100%"
                hide-delimiters
                :show-arrows="hasSlides(currentExhibitor)"
                show-arrows-on-hover
                v-model="currentSlide"
                @change="centerSelectedSlide"
              >
                <v-carousel-item
                  v-for="(video, index) in currentExhibitor.video_urls || []"
                  :key="`video-${index}`"
                >
                  <iframe
                    v-if="detailView && index === currentSlide"
                    :src="embeddedVideoUrl(video)"
                    frameborder="0"
                    allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture"
                    allowfullscreen="allowfullscreen"
                  ></iframe>
                </v-carousel-item>
                <v-carousel-item
                  v-for="picture in currentExhibitor.picture_file_entries || []"
                  :key="picture.id"
                >
                  <v-img height="100%" contain :src="picture.asset_url">
                    <v-row align="end" class="lightbox white--text fill-height">
                      <v-toolbar
                        class="headline"
                        :color="
                          currentExhibitor.hex_color
                            ? currentExhibitor.hex_color
                            : 'primary'
                        "
                        v-if="picture.title"
                      >
                        <div
                          :class="
                            `subheading pa-4 ${
                              !hasDarkText(currentExhibitor.hex_color)
                                ? 'black--text'
                                : ''
                            }`
                          "
                          v-html="
                            getTranslatedText(picture.title, picture.title_en)
                          "
                        ></div>
                      </v-toolbar>
                    </v-row>
                  </v-img>
                </v-carousel-item>
              </v-carousel>
            </div>
          </v-row>
          <v-row
            v-if="hasSlides(currentExhibitor)"
            justify="center"
            class="exhibitor-row"
            ref="sliderParent"
            v-resize="sliderPreviewResize"
          >
            <div ref="sliderButtons" class="slider-buttons">
              <v-btn-toggle
                v-model="currentSlide"
                mandatory
                @change="centerSelectedSlide"
              >
                <v-btn
                  v-for="(video, index) in currentExhibitor.video_urls || []"
                  :key="`video-button-${index}`"
                  class="pa-0"
                  :color="
                    currentSlide === index
                      ? currentExhibitor.hex_color
                        ? currentExhibitor.hex_color
                        : 'primary'
                      : undefined
                  "
                >
                  <v-icon
                    :color="
                      currentSlide === index
                        ? 'white'
                        : currentExhibitor.hex_color
                        ? currentExhibitor.hex_color
                        : 'primary'
                    "
                    >mdi-youtube</v-icon
                  >
                </v-btn>
                <v-btn
                  v-for="(picture,
                  index) in currentExhibitor.picture_file_entries || []"
                  :key="picture.id"
                  class="pa-0"
                >
                  <v-img
                    height="48px"
                    width="48px"
                    class="pa-2"
                    :src="picture.asset_url"
                    contain
                  >
                  </v-img>
                  <v-overlay
                    absolute
                    :color="
                      currentExhibitor.hex_color
                        ? currentExhibitor.hex_color
                        : 'primary'
                    "
                    :value="
                      currentSlide ===
                        index +
                          (currentExhibitor.video_urls
                            ? currentExhibitor.video_urls.length
                            : 0)
                    "
                  >
                  </v-overlay>
                </v-btn>
              </v-btn-toggle>
            </div>
          </v-row>
          <v-row
            v-if="hasSlides(currentExhibitor)"
            justify="center"
            class="exhibitor-row"
          >
            <p class="subtitle-2 font-weight-bold mt-2 mb-2">
              {{ currentSlide + 1 }} /
              {{
                (currentExhibitor.picture_file_entries
                  ? currentExhibitor.picture_file_entries.length
                  : 0) +
                  (currentExhibitor.video_urls
                    ? currentExhibitor.video_urls.length
                    : 0)
              }}
            </p>
          </v-row>
          <v-row
            v-if="currentExhibitor.company_address"
            class="ma-2 mt-4 subtitle-2 exhibitor-address"
          >
            <span
              class="richtext"
              v-html="currentExhibitor.company_address"
            ></span>
          </v-row>
          <v-divider></v-divider>
          <v-row
            v-if="
              currentExhibitor.contact_email || currentExhibitor.contact_phone
            "
            class="ml-1"
          >
            <v-btn
              small
              text
              :href="`mailto:${currentExhibitor.contact_email}`"
              :color="
                currentExhibitor.hex_color
                  ? hasDarkText(currentExhibitor.hex_color)
                    ? currentExhibitor.hex_color
                    : 'black'
                  : 'primary'
              "
              class="custom-link"
            >
              <v-icon small left>mdi-email</v-icon>
              {{ currentExhibitor.contact_email }}
            </v-btn>
            <v-btn
              v-if="currentExhibitor.contact_phone"
              small
              text
              :href="`tel:${currentExhibitor.contact_phone}`"
              :color="
                currentExhibitor.hex_color
                  ? hasDarkText(currentExhibitor.hex_color)
                    ? currentExhibitor.hex_color
                    : 'black'
                  : 'primary'
              "
              class="custom-link"
            >
              <v-icon small left>mdi-phone</v-icon>
              {{ currentExhibitor.contact_phone }}
            </v-btn>
          </v-row>
          <v-row class="ma-2">
            <v-btn
              :color="
                currentExhibitor.hex_color
                  ? currentExhibitor.hex_color
                  : 'primary'
              "
              :dark="hasDarkText(currentExhibitor.hex_color)"
              fab
              class="mr-2 custom-link"
              :href="currentExhibitor.company_url"
              target="_blank"
              small
              v-if="currentExhibitor.company_url"
            >
              <v-icon>mdi-web</v-icon>
            </v-btn>
            <v-btn
              :color="
                currentExhibitor.hex_color
                  ? currentExhibitor.hex_color
                  : 'primary'
              "
              :dark="hasDarkText(currentExhibitor.hex_color)"
              fab
              class="mr-2 custom-link"
              :href="currentExhibitor.facebook_url"
              target="_blank"
              small
              v-if="currentExhibitor.facebook_url"
            >
              <v-icon>mdi-facebook</v-icon>
            </v-btn>
            <v-btn
              :color="
                currentExhibitor.hex_color
                  ? currentExhibitor.hex_color
                  : 'primary'
              "
              :dark="hasDarkText(currentExhibitor.hex_color)"
              fab
              class="mr-2 custom-link"
              :href="currentExhibitor.x_url"
              target="_blank"
              small
              v-if="currentExhibitor.x_url"
            >
              <v-icon>mdi-twitter</v-icon>
            </v-btn>
            <v-btn
              :color="
                currentExhibitor.hex_color
                  ? currentExhibitor.hex_color
                  : 'primary'
              "
              :dark="hasDarkText(currentExhibitor.hex_color)"
              fab
              class="mr-2 custom-link"
              :href="currentExhibitor.youtube_url"
              target="_blank"
              small
              v-if="currentExhibitor.youtube_url"
            >
              <v-icon>mdi-youtube</v-icon>
            </v-btn>
            <v-btn
              :color="
                currentExhibitor.hex_color
                  ? currentExhibitor.hex_color
                  : 'primary'
              "
              :dark="hasDarkText(currentExhibitor.hex_color)"
              fab
              class="mr-2 custom-link"
              :href="currentExhibitor.linkedin_url"
              target="_blank"
              small
              v-if="currentExhibitor.linkedin_url"
            >
              <v-icon>mdi-linkedin</v-icon>
            </v-btn>
            <v-btn
              :color="
                currentExhibitor.hex_color
                  ? currentExhibitor.hex_color
                  : 'primary'
              "
              :dark="hasDarkText(currentExhibitor.hex_color)"
              fab
              class="mr-2 custom-link"
              :href="currentExhibitor.xing_url"
              target="_blank"
              small
              v-if="currentExhibitor.xing_url"
            >
              <v-icon>mdi-xing</v-icon>
            </v-btn>
          </v-row>
        </v-card-text>
      </v-card>
    </v-dialog>
  </v-container>
</template>

<script>
import { mapGetters } from "vuex";
import { i18n } from "../plugins/i18n";
import {
  executiveExhibitorsResource,
  executiveExhibitorsTagResource,
} from "./../api/resources";
import VClamp from "vue-clamp";

export default {
  async mounted() {
    let exhibitors = (
      await executiveExhibitorsResource(
        this.executiveProgramUrl,
        this.externalEventId
      ).get("")
    ).data;
    let allTags = (
      await executiveExhibitorsTagResource(this.executiveProgramUrl).get("")
    ).data;
    const localeTags = [];
    exhibitors.forEach((exhibitor) => {
      if (!exhibitor.tag_ids || !exhibitor.tag_ids.length) {
        return;
      }
      exhibitor.tag_ids.forEach((tagId) => {
        const tag = allTags.find((element) => element.id === tagId);
        if (!tag) {
          return;
        }
        if (localeTags.find((element) => element.id === tagId.id)) {
          return;
        }
        localeTags.push({
          id: tagId,
          title: (this.exhibitionLocale === "en" ? tag.title_en : tag.title)
            .trim()
            .toUpperCase(),
        });
      });
    });
    localeTags.sort((a, b) => a.title.localeCompare(b.title));
    this.tags = localeTags;
    // shuffle
    this.exhibitors = exhibitors.sort(() => Math.random() - 0.5);
  },
  components: {
    VClamp,
  },
  data: () => ({
    page: 1,
    itemsPerPage: 6,
    currentSlide: 0,
    search: "",
    currentExhibitor: {},
    detailView: false,
    exhibitors: [],
    tags: [],
    filterTagIds: [],
  }),
  computed: {
    ...mapGetters([
      "pageSettings",
      "embeddedVideoUrl",
      "externalEventId",
      "executiveProgramUrl",
    ]),
    exhibitionLocale() {
      return i18n.locale;
    },
    numberOfPages() {
      return Math.ceil(this.filteredExhibitors.length / this.itemsPerPage);
    },
    filteredExhibitors() {
      if (this.filterTagIds.length === 0) {
        return this.exhibitors;
      }
      return this.exhibitors.filter((exhibitor) =>
        exhibitor.tag_ids.some((tagId) =>
          this.filterTagIds.some((filterTagId) => filterTagId === tagId)
        )
      );
    },
    cssVariables() {
      return {
        "--scrollbar-color": this.currentExhibitor.hex_color
          ? this.currentExhibitor.hex_color
          : "#a21c26",
      };
    },
  },
  methods: {
    getTranslatedText(germanText, englishText) {
      if (this.exhibitionLocale === "en") {
        return englishText || germanText;
      }
      return germanText || englishText;
    },
    hasDarkText(color) {
      if (!color) {
        return true;
      }
      let r = 0;
      let g = 0;
      let b = 0;
      if (color.match(/^rgb/)) {
        color = color.match(
          /^rgba?\((\d+),\s*(\d+),\s*(\d+)(?:,\s*(\d+(?:\.\d+)?))?\)$/
        );
        r = color[1];
        g = color[2];
        b = color[3];
      } else {
        color = +(
          "0x" + color.slice(1).replace(color.length < 5 && /./g, "$&$&")
        );
        r = color >> 16;
        g = (color >> 8) & 255;
        b = color & 255;
      }
      const hsp = Math.sqrt(
        0.299 * (r * r) + 0.587 * (g * g) + 0.114 * (b * b)
      );
      return hsp < 200;
    },
    getRichTextString(richText, stripHtmlTags) {
      let htmlText = "";
      if (!richText || !richText.items) {
        return htmlText;
      }
      htmlText = richText.items
        .map((element) => element.content.replaceAll("<p><br />", "<p>"))
        .join();
      if (stripHtmlTags) {
        const tmp = document.createElement("DIV");
        tmp.innerHTML = htmlText;
        return tmp.textContent || tmp.innerText || "";
      }
      return htmlText;
    },
    getTranslatedTags(exhibitor) {
      if (!exhibitor.tag_ids) {
        return [];
      }
      return exhibitor.tag_ids.map((tagId) => {
        const tag = this.tags.find((element) => element.id === tagId);
        return (this.exhibitionLocale === "en" ? tag.title_en : tag.title)
          .trim()
          .toUpperCase();
      });
    },
    hasImageOrVideo(exhibitor) {
      if (exhibitor.video_urls && exhibitor.video_urls.length > 0) {
        return true;
      }
      if (
        exhibitor.picture_file_entries &&
        exhibitor.picture_file_entries.length > 0
      ) {
        return true;
      }
      return false;
    },
    hasSlides(exhibitor) {
      let slideCount = 0;
      if (exhibitor.video_urls) {
        slideCount += exhibitor.video_urls.length;
      }
      if (exhibitor.picture_file_entries) {
        slideCount += exhibitor.picture_file_entries.length;
      }
      return slideCount > 1;
    },
    nextPage() {
      if (this.page + 1 <= this.numberOfPages) {
        this.page += 1;
      }
    },
    formerPage() {
      if (this.page - 1 >= 1) {
        this.page -= 1;
      }
    },
    showDetailView(exhibitor) {
      this.currentExhibitor = exhibitor;
      this.currentSlide = 0;
      this.detailView = true;
    },
    downloadDocument(url) {
      window.open(url, "_blank");
    },
    centerSelectedSlide() {
      const overalWidth = this.$refs.sliderParent.clientWidth;
      const sliderWidth = this.$refs.sliderButtons.clientWidth;
      let left = 0;

      // check that selected slide is still visible on mobile view by centering
      if (sliderWidth >= overalWidth) {
        let slideCount = 0;
        if (this.currentExhibitor.video_urls) {
          slideCount += this.currentExhibitor.video_urls.length;
        }
        if (this.currentExhibitor.picture_file_entries) {
          slideCount += this.currentExhibitor.picture_file_entries.length;
        }
        const slideWidth = sliderWidth / slideCount;
        const selectionX = slideWidth * this.currentSlide;
        const minimumShift = (sliderWidth - overalWidth) / 2;
        if (selectionX < minimumShift * 2) {
          left = minimumShift;
        } else if (selectionX > overalWidth - minimumShift) {
          left = -minimumShift;
        }
      }
      this.$refs.sliderButtons.style.left = `${left}px`;
    },
    sliderPreviewResize() {
      this.$nextTick(() => this.centerSelectedSlide());
    },
  },
};
</script>

<style scoped>
.exhibitor-image {
  width: 100%;
}
.video-container {
  position: relative;
  padding-bottom: 56.25%; /* 16:9 */
  width: 100%;
  height: 0;
}
.video-container iframe,
.video-container > div {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
}
.video-container header {
  opacity: 0.8;
}
.richtext {
  margin-bottom: -16px;
}
.v-dialog__content {
  z-index: 9999;
}
.v-card__text {
  overflow-x: hidden;
}
.v-card__text::-webkit-scrollbar {
  width: 12px;
}
.v-card__text::-webkit-scrollbar-thumb {
  background: var(--scrollbar-color);
}
.exhibitor-row {
  position: relative;
}
.odd-background {
  position: absolute;
  background-color: var(--scrollbar-color);
  opacity: 0.08;
  width: 200%;
  margin-left: -24px;
  height: 100%;
}
.slider-buttons {
  position: relative;
}
.exhibitor-address >>> p:not(:last-child) {
  margin-bottom: 0;
}
</style>
